import { Button, Menu, Radio, Tooltip } from '@mantine/core';
import { Icon, sizes, variants } from '@uag/react-core';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { SettingModelSettingType } from 'api/models';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SettingTypeFilter = () => {
    const { t } = useTranslation();

    const [opened, setOpened] = useState<boolean>(false);
    const [settingType, setSettingType] = useState<SettingModelSettingType | undefined>(
        usePlacementStore.getState().settingTypeFilter
    );

    const setSettingTypeFilter = usePlacementStore(useShallow((state) => state.setSettingTypeFilter));

    const handleOnReset = useCallback(() => {
        setSettingType(undefined);
        setSettingTypeFilter(undefined);
    }, [setSettingTypeFilter]);

    const handleOnApply = useCallback(() => {
        setSettingTypeFilter(settingType);
    }, [settingType, setSettingTypeFilter]);

    return (
        <Menu offset={0} opened={opened} position="bottom-end" shadow="md" onChange={setOpened}>
            <Menu.Target>
                <Tooltip label={t('labelCatalogueFilter')} position="bottom" variant={variants.tooltip.bottom}>
                    <Button className="ml-2 focus:bg-background-default!" size={sizes.button.small} variant={variants.button.secondary}>
                        <Icon className="text-text-accent" icon={'filter_alt'} />
                    </Button>
                </Tooltip>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label className="mt-2">{t('labelCatalogueFilter')}</Menu.Label>
                <Menu.Divider />
                <div className="p-3 mb-3">
                    <Radio.Group
                        value={settingType}
                        onChange={(value) => setSettingType(value as SettingModelSettingType)}
                    >
                        {Object.entries(SettingModelSettingType).map(([value, label]) => (
                            <Radio key={value} label={label} value={value} />
                        ))}
                    </Radio.Group>
                </div>

                <div className="min-w-52 flex justify-end gap-2 mr-2 mb-2">
                    <Button size={sizes.button.small} variant={variants.button.secondary} onPointerDown={handleOnReset}>
                        {t('reset')}
                    </Button>
                    <Button size={sizes.button.small} onPointerDown={handleOnApply}>{t('apply')}</Button>
                </div>
            </Menu.Dropdown>
        </Menu>
    );
};
